module.exports = __webpack_public_path__ + "static/media/icon-clover.dfbb1c5f.svg";